import { createSearchParams } from 'react-router-dom-latest';
import { BoxSkeleton, Divider, Stack } from '@common-components';
import { demoData } from 'utils';
import { BROKER_NESTED_ROUTES } from 'broker/broker-routes';
import DataGridNoResults from 'broker/components/common/QuotesAndPolicies/DataGridNoResults';
import { UrlParam } from 'broker/dialogs/CarrierDialog/utils';
import { RouteKey } from 'broker/enums';
import MainScrollArea from 'broker/hoc/MainScrollArea';
import { useNavigate } from 'broker/hooks';
import CarriersTableHeader from './CarriersTableHeader';
import CarriersTableItem from './CarriersTableItem';
import { CarrierOnClick, ExtendedCarrier } from './types';

interface CarriersTableViewProps {
  carriers: ExtendedCarrier[];
  isLoading: boolean;
  searchInput?: string;
  checkedLabels?: string[];
}

export default function CarriersTableView({
  carriers,
  isLoading,
  searchInput = '',
  checkedLabels = [],
}: CarriersTableViewProps) {
  const navigate = useNavigate();

  const openEditModal: CarrierOnClick = ({ id, scrollTo }) => {
    navigate(
      {
        pathname: BROKER_NESTED_ROUTES.CARRIERS.CARRIER,
        search: `${createSearchParams([[UrlParam.Id, id]])}`,
      },
      {
        routeKey: RouteKey.Carrier,
        state: { scrollTo },
      },
    );
  };

  const items =
    carriers.length > 0 ? (
      carriers.map((carrier) => (
        <CarriersTableItem
          carrier={carrier}
          key={carrier.id}
          onClick={openEditModal}
          searchInput={searchInput}
          checkedLabels={checkedLabels}
        />
      ))
    ) : (
      <DataGridNoResults />
    );

  const skeleton = (
    <Stack gap={2} p={2}>
      {demoData(10).map((row, index) => (
        <Stack gap={2} key={row.id}>
          <BoxSkeleton isLoading sx={{ width: 1, height: 45 }} index={index} />
          <Divider />
        </Stack>
      ))}
    </Stack>
  );

  return (
    <Stack overflow="hidden" flex="1 1 0">
      <MainScrollArea id="carriersScrollArea" flex={1} sx={{ overflowY: 'auto', overflowX: 'hidden' }}>
        <CarriersTableHeader />
        {isLoading ? skeleton : items}
      </MainScrollArea>
    </Stack>
  );
}
